var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDbkChain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.112 16.8C22.112 20.7765 18.8401 24 14.804 24H1V19.2H14.804C16.1493 19.2 17.24 18.1255 17.24 16.8C17.24 15.4745 16.1493 14.4 14.804 14.4H9.93204V9.6H14.804C16.1493 9.6 17.24 8.52549 17.24 7.2C17.24 5.87451 16.1493 4.8 14.804 4.8H1V0H14.804C18.8401 0 22.112 3.22355 22.112 7.2C22.112 9.04406 21.4083 10.7262 20.2512 12C21.4083 13.2738 22.112 14.9559 22.112 16.8Z",
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00002 4.8H12.8563C10.3378 1.88533 6.32818 0 1.81201 0C1.53943 0 1.26869 0.00686829 1.00002 0.0204166V4.8ZM15.3399 14.4H10.744V9.6H15.3399C15.521 10.3755 15.616 11.1781 15.616 12C15.616 12.8219 15.521 13.6245 15.3399 14.4ZM1 19.2H12.8562C10.3378 22.1147 6.32816 24 1.812 24C1.53942 24 1.26867 23.9931 1 23.9796V19.2Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0C7.72682 0 13.18 5.37258 13.18 12C13.18 18.6274 7.72682 24 1 24V19.2C5.0361 19.2 8.308 15.9765 8.308 12C8.308 8.02355 5.0361 4.8 1 4.8V0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbkChain);
export default __webpack_public_path__ + "static/media/dbk-chain.53e07f624cccce0f0fa07e7045286626.svg";
export { ForwardRef as ReactComponent };